<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2.4" y="5" width="15.2" height="10" rx="2"/><circle cx="10" cy="10" r="2.4"/><path d="M5.4 8v4M14.6 8v4"/></svg>
</template>
